import { memo } from 'react';
import { Marker, useMap } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import useSupercluster from 'use-supercluster';
import { useCamera } from '../../../hooks/useCamera';
import { useStyles } from '../../../hooks/useStyles';
import { mapCurrentStatesGeoJson, mapViewState } from '../../../storage/map';
import CurrentStateMarker from './CurrentStateMarker';

function Clusters() {
  const { map } = useMap();
  const { css, theme } = useStyles();
  const { zoomTo } = useCamera();
  const viewState = useRecoilValue(mapViewState);
  const mapCurrentStatesGeojson = useRecoilValue(mapCurrentStatesGeoJson);
  const mapBounds = map?.getBounds();
  const bounds = mapBounds ? (mapBounds.toArray().flat() as [number, number, number, number]) : undefined;

  const { clusters } = useSupercluster({
    points: mapCurrentStatesGeojson,
    bounds: bounds,
    zoom: viewState.zoom,
    options: { radius: 50, maxZoom: 17 },
  });

  return (
    <>
      {clusters.map((cluster) => {
        const [lng, lat] = cluster.geometry.coordinates;
        const { cluster: isCluster, point_count: pointCount, ident } = cluster.properties;

        if (isCluster) {
          return (
            <Marker
              key={`cluster-${cluster.id}`}
              latitude={lat}
              longitude={lng}
              onClick={() => zoomTo({ lat, lng }, viewState.zoom + 3 < 12 ? viewState.zoom + 3 : 12)}
            >
              <div
                className={css({
                  ...theme.typography.LabelSmall,
                  backgroundImage: "url('/img/icons/map/cluster.png')",
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '50px',
                  height: '50px',
                  fontWeight: '700',
                })}
              >
                {pointCount}
              </div>
            </Marker>
          );
        }

        if (ident) {
          return (
            <CurrentStateMarker
              key={ident}
              ident={ident}
            />
          );
        }
        return null;
      })}
    </>
  );
}

export default memo(Clusters);
